import React from "react";
import { forEach } from "lodash";
import FontIcon from "react-md/lib/FontIcons";
import Avatar from "react-md/lib/Avatars";

import List from "../List";
import {DebugElement} from "../../Atollon/debug";

const userAvatar = <Avatar icon={<FontIcon>person</FontIcon>} suffix="black" />;

const Lists = ({ users, history }) => {
  const admins = [];

    console.log( 'Lists users', users );

  forEach(
    users,
    u => {
        console.log(u.role === "ADMIN", u.role);
      u.role === "ADMIN" &&
      admins.push({
        primary: u.name,
        secondary: u.identifier,
        onClick: () => history.push(`/person/${u.identifier}`)
      })
    }
  );

  const dispatchers = [];
  forEach(
    users,
    u => {
        console.log(u.role === "DISPATCHER", u);
      u.role === "DISPATCHER" &&
      dispatchers.push({
        primary: u.name,
        secondary: u.identifier,
        onClick: () => history.push(`/person/${u.identifier}`)
      })
    }
  );

  return (
    <div className="flex-row main-tables">
        <DebugElement text={"src/components/project/Lists.js"}/>
      <div className="main-table">
        <List title="Správci projektu" items={admins} leftAvatar={userAvatar} />
      </div>
      <div className="main-table">
        <List
          title="Členové projektu"
          items={dispatchers}
          leftAvatar={userAvatar}
        />
      </div>
    </div>
  );
};

export default Lists;



// WEBPACK FOOTER //
// ./src/components/project/Lists.js